/**
 * Painel da conta: quem esta logado, em qual tenant, em qual plano, e a saida.
 *
 * Responsabilidade: mostrar o que `store.obter().sessao` diz, e oferecer o
 * botao de sair.
 *
 * NAO e responsabilidade deste arquivo: encerrar a sessao. A ordem (parar o
 * socket, chamar `POST /v1/auth/logout`, limpar o que este navegador guardou,
 * trocar de tela) mora no `main.ts`, num lugar so; daqui sai so o clique.
 *
 * ## Por que a conta esta na aba Sistema
 *
 * Ate a folha existir, isto era um `<dialog>` aberto pelo botao do cabecalho —
 * o mesmo botao que agora abre a folha. Dois destinos no mesmo canto seriam um
 * a mais do que o painel local tem. E a conta pertence a Sistema pelo mesmo
 * criterio que la: e o que identifica ESTA instalacao, ao lado do feed de
 * comandos, e nao um parametro do cultivo.
 *
 * ## `sessao` nula nao e erro
 *
 * Offline, o painel abre do cache e o `GET /v1/auth/me` ainda nao voltou (ver o
 * cabecalho do `main.ts`). Os campos ficam em traco, como todo valor que esta
 * PWA nao conhece — e o botao de sair continua valendo, porque apagar o que
 * este navegador guardou nao depende de rede.
 */

import * as store from "./../store";
import { el, type Painel } from "./../ui";

export function montar(aoSair: () => void): Painel {
  const email = el("p", { class: "conta-email", text: "—" });
  const plano = el("p", { class: "hint", text: "—" });

  const raiz = el(
    "section",
    { class: "panel card", id: "conta" },
    el(
      "div",
      { class: "panel-head" },
      el("span", { class: "panel-title", text: "Conta" }),
      el("button", {
        type: "button",
        class: "perigo",
        text: "Sair",
        onclick: aoSair,
      }),
    ),
    email,
    plano,
  );

  function atualizar(): void {
    const sessao = store.obter().sessao;
    email.textContent = sessao?.email ?? "—";
    plano.textContent = `${sessao?.tenant_name ?? "—"} · plano ${sessao?.tier ?? "—"}`;
  }

  return { raiz, atualizar };
}
